import { useEffect, useRef, useState } from "react";

import styles from "../dash_styles/addproduct.module.css";

import getImgUrl from "../../helper/getImgUrl";
import api from '../../api/axios';
import CurrencyDisplay from "../dash_component/CurrencyDisplay";

import { IoAddSharp } from "react-icons/io5";
import { MdClose } from "react-icons/md";
import { GoUpload } from "react-icons/go";
import { CiSquareAlert } from "react-icons/ci";
import { CiTrash } from "react-icons/ci";

const AddProduct = () => {
    const [formData, setFormData] = useState({
        title: '',
        type: '',
        price: '',
        productdesc: '',
        quantity: '',
        cost: ''
    });
    const [newImages, setNewImages] = useState({});
    const [imagePreviews, setImagePreviews] = useState({});
    const [materialsInput, setMaterialsInput] = useState([]);
    const [productList, setProductList] = useState([]);
    const [isContainerOpen, setIsContainerOper] = useState(false);
    const fileInputRefs = useRef([]);


    const fetchProducts = async () => {
        try {
            const response = await api.get('/product/list');
            setProductList(response.data);
        } catch (error) {
            console.error('Error fetching products:', error);
        } 
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    const stockIcons = (quantity) => {
        if (quantity <= 3) {
            return <CiSquareAlert style={{ color: 'red'}}/>
        } else if (quantity <= 6) {
            return <CiSquareAlert style={{ color: 'rgb(183, 183, 69)'}}/>
        } else if (quantity <= 10) {
            return <CiSquareAlert style={{ color: 'green'}}/>
        }
    };

    const handleUploadClick = (index) => {
        fileInputRefs.current[index].click();
    };
    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value}));
    };

    const handleMatrialsChange = (e) => {
        setMaterialsInput(e.target.value.split(',').map(mat => mat.trim()));
    };

    const handleImgageChange = (e, index) => {
        const file = e.target.files[0];
        if (file) {
            setNewImages(prev => ({ ...prev, [index]: file }));
            setImagePreviews(prev => ({ ...prev, [index]: URL.createObjectURL(file) }));
        }
    };

    useEffect(() => {
        return () => {
            Object.values(imagePreviews).forEach(url => URL.revokeObjectURL(url));
        };
    }, [imagePreviews]);

    const handleAddProduct = async (e) => {
        e.preventDefault();

        try {
            const data = new FormData();
            data.append('title', formData.title);
            data.append('price', formData.price);
            data.append('type', formData.type);
            data.append('productdesc', formData.productdesc);
            data.append('quantity', formData.quantity);
            data.append('cost', formData.cost);

            materialsInput.forEach(m => data.append('materials', m));

            Object.entries(newImages).forEach(([index, file]) => {
                data.append('images', file);
            });

            await api.post(
                '/productmgmt/add',
                data,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            alert(`${formData.title} was added successfully`);
            await fetchProducts();
            setFormData({
                title: '',
                type: '',
                price: '',
                productdesc: '',
                quantity: '',
                cost: ''
            });
            setMaterialsInput('');
            setNewImages({});
            setIsContainerOper(false);
            setImagePreviews({})
        } catch (error) {
            console.error('Error adding product:', error);
            alert('Failed to add product');
        }
    };

    const handleDeleteProduct = async (id) => {
        if (!window.confirm('Are you sure you want to delete this product?')) return;

        try {
            await api.delete(`/productmgmt/delete/${id}`);
            await fetchProducts();
        } catch (error) {
            console.error('Error deleting product', error);
            alert('Failed to delete product');
        }
    }

    const handleCancelForm = () => {
        setFormData({})
        setIsContainerOper(false);
        setImagePreviews({})
    }

    return (
        <div className={styles.mainContainer}>
            <div className={styles.productGrid}>
                <div className={styles.productContainer}>
                    <div className={styles.addProduct}>
                        <div className={styles.content}>
                            <div className={styles.addBtn} onClick={() => setIsContainerOper(prev => !prev)}>
                                <IoAddSharp className={styles.addIcon}/>
                            </div>
                            <p>Creat New Product</p>
                        </div>
                    </div>
                </div>
                {Array.isArray(productList) && productList.map(product => (
                    <div className={styles.productCard} key={product.id}>
                        <div className={styles.imgCard}>
                            <img 
                                src={getImgUrl(product.images[0], 'product')}
                                alt="Product"
                            />
                        </div>
                        <div className={styles.productInfoPreview}>
                            <div className={styles.cardInfo}>
                                <p className={styles.capital}>name</p><p className={styles.info}>{product.title}</p>
                            </div>
                            <div className={styles.cardInfo}>
                                <p className={styles.capital}>price</p><p className={styles.info}><CurrencyDisplay amount={product.price} currency='CAD'/></p>
                            </div>
                            <div className={styles.cardInfo}>
                                <p className={styles.capital}>cost</p><p className={styles.info}><CurrencyDisplay amount={product.cost} currency='CAD'/></p>
                            </div>
                            <div className={styles.cardInfo}>
                                <p className={styles.capital}>type</p><p className={styles.info}>{product.type}</p>
                            </div>
                            <div className={styles.stockBox}>
                                <div className={styles.alertBox}>
                                    <div className={styles.alertIcon}>{stockIcons(product.quantity)}</div>
                                    <div><p>QUANTITY: {product.quantity}</p></div>
                                </div>    
                                
                                <div className={styles.deleteProduct}><CiTrash onClick={() => handleDeleteProduct(product.id)}/></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className={`${styles.addWrapper} ${isContainerOpen ? styles.show : ''}`}>
                <div className={styles.addContainer}>
                    <div className={styles.topAdd}>
                        <MdClose className={styles.closeIcon} onClick={handleCancelForm}/>
                    </div>
                    <div className={styles.middleAdd}>
                        <form id="feedForm" onSubmit={handleAddProduct}>
                            <div className={styles.productInfo}>
                                <div className={styles.title}><p>Product Info</p></div>
                                <div className={styles.productFormContent}>
                                    <div className={styles.inputBox}>
                                        <p>Product name</p>
                                        <input
                                            type="text"
                                            name="title"
                                            placeholder="Enter name of product"
                                            value={formData.title}
                                            onChange={handleInputChange}
                                            maxLength={50}
                                        />
                                    </div>
                                    <div className={styles.inputBox}>
                                        <p>product type</p>
                                        <input
                                            name="type"
                                            type="text"
                                            placeholder="Enter product type"
                                            value={formData.type}
                                            onChange={handleInputChange}
                                            maxLength={50}
                                        />
                                    </div>
                                    <div className={styles.inputBox}>
                                        <p>product price</p>
                                        <input
                                            name="price"
                                            type="text"
                                            placeholder="Enter price of product"
                                            value={formData.price}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className={styles.inputBox}>
                                        <p>cost of product</p>
                                        <input
                                            name="cost"
                                            type="text"
                                            placeholder="Enter cost of product"
                                            value={formData.cost}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className={styles.inputBox}>
                                        <p>material available</p>
                                        <input
                                            name="materials"
                                            type="text"
                                            placeholder="Enter material available"
                                            value={materialsInput}
                                            onChange={handleMatrialsChange}
                                        />
                                    </div>
                                    <div className={styles.inputBox}>
                                        <p>stock quantity</p>
                                        <input
                                            name="quantity"
                                            type="number"
                                            placeholder="Stock availabilty"
                                            value={formData.quantity}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className={styles.inputBoxArea}>
                                        <p>Product description</p>
                                        <textarea 
                                            name="productdesc"
                                            placeholder="Describe the product"
                                            value={formData.productdesc}
                                            onChange={handleInputChange}
                                            maxLength={370}
                                            className={styles.textareaAdd}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.productMedia}>
                                <div className={styles.title}><p>Product Media</p></div>
                                <div className={styles.innerMedia}>
                                    <div className={styles.inputBoxMedia}>
                                        <p>Main Photo</p>
                                        <img src={imagePreviews[0] || '/imgs/defautp.webp'} alt="Preview"/>
                                        <div onClick={() => handleUploadClick(0)} className={styles.customeUploader}> 
                                            <GoUpload/> <h4 className={styles.special}>Upload Image</h4>
                                        </div>
                                        <input
                                            name="images"
                                            type="file"
                                            ref={(el) => (fileInputRefs.current[0] = el)}
                                            className={styles.hiddenFileInput}
                                            onChange={(e) => handleImgageChange(e, 0)}
                                        />
                                    </div>
                                    <div className={styles.inputBoxMedia}>
                                        <p>second Photo</p>
                                        <img src={imagePreviews[1] || '/imgs/defautp.webp'} alt="Preview"/>
                                        <div onClick={() => handleUploadClick(1)} className={styles.customeUploader}> 
                                            <GoUpload/> <h4 className={styles.special}>Upload Image</h4>
                                        </div>
                                        <input
                                            name="images"
                                            type="file"
                                            ref={(el) => (fileInputRefs.current[1] = el)}
                                            className={styles.hiddenFileInput}
                                            onChange={(e) => handleImgageChange(e, 1)}
                                        />
                                    </div>
                                    <div className={styles.inputBoxMedia}>
                                        <p>third Photo</p>
                                        <img src={imagePreviews[2] || '/imgs/defautp.webp'} alt="Preview"/>
                                        <div onClick={() => handleUploadClick(2)} className={styles.customeUploader}> 
                                            <GoUpload/> <h4 className={styles.special}>Upload Image</h4>
                                        </div>
                                        <input
                                            name="images"
                                            type="file"
                                            ref={(el) => (fileInputRefs.current[2] = el)}
                                            className={styles.hiddenFileInput}
                                            onChange={(e) => handleImgageChange(e, 2)}
                                        />
                                    </div>
                                    
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className={styles.bottomAdd}>
                        <button onClick={handleCancelForm}>Cancel</button>
                        <button type="submit" form="feedForm" className={styles.save}>Create</button>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default AddProduct;